<template>
  <div>
    <v-alert
      border="left"
      colored-border
      type="warning"
      elevation="2"
      style="font-size: 90%"
    >
      <h1 class="mb-5">
        サポート対象外のブラウザをご利用されています
      </h1>
      <div>
        <p>健康チャレンジキャンペーンでは、サポート対象外のブラウザでアクセスされています。</p>
        <p>大変お手数ですが、下記のいずれかの方法でご利用ください。</p>
        <v-divider class="mb-2"></v-divider>
        <h2 class="mb-2"> 1．PCからアクセスする</h2>
        <p>Microsoft Edge<img src="@/assets/edge.png" width="30px">または、Google Chrome<img src="@/assets/chrome.png" width="30px">でご利用ください。</p>
        <a class="ml-3" :href="edgeUrl">Microsoft Edgeで開く</a>
        <p class="mt-5">上記でご利用できない場合は、スマートフォンからアクセスしてください。</p>

        <v-divider class="mb-2"></v-divider>
        <h2 class="mb-2"> 2．スマートフォンからアクセスする</h2>
        <p>お使いのスマートフォンから下記のURLにアクセスしご利用ください。</p>
        <p>{{kehcnareUrl}}</p>
        <vue-qrcode :value="kehcnareUrl" tag="img"></vue-qrcode>
        <p>QRコードリーダーでURLを読み込みした後、下記のブラウザでご利用ください。</p>
        <ul>
          <li>Apple Safari</li>
          <li>Google Chrome</li>
        </ul>

        <v-divider class="my-5"></v-divider>
        <p>※管理者の方で、IEから管理画面を閲覧したい場合は下記よりお入りください。</p>
        <v-btn
          @click="toLogin"
          color="primary"
          class="ml-3"
        >
          【管理者限定】IEからログイン
        </v-btn>
      </div>
    </v-alert>
  </div>
</template>
<script>
import Vue from 'vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
export default Vue.extend({
  name: 'BrowserSupport',
  props: ['config'],
  components: {
    VueQrcode
  },
  data () {
    return {}
  },
  computed: {
    edgeUrl () {
      return 'microsoft-edge:' + location.href
    },
    kehcnareUrl () {
      return location.href
    }
  },
  methods: {
    toLogin () {
      this.$emit('fromIE')
    }
  }
})
</script>
